import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => ({
  toolbarContainer: {
    backgroundColor: 'rgba(13, 20, 28, 0.9)',
    backdropFilter: 'blur(10px)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '90px',
    margin: theme.spacing(2),
    borderRadius: '16px',
    padding: '0 20px',
    gap: '12px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.1)'
  },
  paper: {
    position: 'absolute',
    display: 'flex',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  },
  toolbarMobileContainer: {
    backgroundColor: 'rgba(13, 20, 28, 0.9)',
    backdropFilter: 'blur(10px)',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '85px',
    margin: theme.spacing(1),
    borderRadius: '12px',
    padding: '8px 10px',
    gap: '2px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.1)'
  },
  toolbarButtons: {
    margin: theme.spacing(0.5),
    borderRadius: '12px',
    backgroundColor: 'rgba(50, 53, 58, 0.8)',
    color: '#fff',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(50, 53, 58, 0.95)',
      transform: 'translateY(-2px)'
    }
  },
  toolbarButtons2: {
    borderRadius: '12px',
    color: '#fff',
    transition: 'all 0.2s ease',
    '&:hover': {
      transform: 'translateY(-2px)'
    }
  },
  toolbarButtonsSm: {
    margin: theme.spacing(1),
    borderRadius: '5px',
    backgroundColor: '#32353A',
    color: '#fff'
  },
  arrowButton: {
    borderRadius: '5em',
    height: '50px',
    width: '50px',
    backgroundColor: '#32353A',
    color: '#fff'
  },
  arrowButton2: {
    borderRadius: '5em',
    height: '50px',
    width: '30px',
    // backgroundColor: '#32353A',
    color: '#fff'
  },
  infoButton: {
    position: 'absolute',
    left: '0',
    margin: theme.spacing(1),
    borderRadius: '5em',
    height: '50px',
    width: '50px',
    backgroundColor: '#32353A',
    color: '#fff'
  },
  groupButton: {
    margin: '8px'
  },
  groupButton2: {
    margin: '5px'
  },
  disabledButton: {
    backgroundColor: theme.palette.activeButtons.red,
    '&:hover': {
      backgroundColor: theme.palette.activeButtons.red,
      opacity: 0.9
    }
  },
  disabledButton2: {
    // backgroundColor: theme.palette.activeButtons.red,
    // '&:hover': {
    //   backgroundColor: theme.palette.activeButtons.red
    // }
  },
  activeButton: {
    backgroundColor: theme.palette.activeButtons.green,
    '&:hover': {
      backgroundColor: theme.palette.activeButtons.green,
      opacity: 0.9
    }
  },
  activeButtonIcon: {
    color: theme.palette.activeButtons.green
  },
  toolLabel: {
    color: 'rgba(255, 255, 255, 0.9)',
    fontSize: '11px',
    textAlign: 'center',
    marginTop: '4px',
    userSelect: 'none',
    fontWeight: '400',
    letterSpacing: '0.3px',
    transition: 'all 0.2s ease'
  },
  toolItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
    padding: '4px',
    transition: 'all 0.2s ease',
    '&:hover': {
      '& $toolLabel': {
        color: '#fff'
      }
    }
  },
  mobileToolItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    minWidth: '48px',
    position: 'relative',
    padding: '4px 2px'
  },
  mobileToolLabel: {
    color: 'rgba(255, 255, 255, 0.9)',
    fontSize: '9px',
    textAlign: 'center',
    userSelect: 'none',
    fontWeight: '400',
    letterSpacing: '0.2px',
    lineHeight: '1',
    marginTop: '2px',
    maxWidth: '60px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
}));
